import script from "./BaseModuleLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseModuleLayout.vue?vue&type=script&setup=true&lang=js"

import "./BaseModuleLayout.vue?vue&type=style&index=0&id=f4234318&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4234318"]])

export default __exports__